/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Input from '../../../../../../components/Input';

export const WhitelistVerifyComponent = ({
  emailConfirmationEnabled,
  totpConfirmationEnabled,
  isUsingTotp,
  emailCode,
  phoneCode,
  email,
  emailCounter,
  phoneCounter,
  setEmailCode,
  setPhoneCode,
  resendPhoneCode,
  resendEmailCode,
  starredPhoneNumber,
}) => {
  const { t: translate } = useTranslation();

  return (
    <>
      {emailConfirmationEnabled && (
        <Input
          label={translate('whitelist_verify_code_email')}
          subLabel={translate('whitelist_verify_code_email_description')
            .replace('%s', email)
            .replace('%d', emailCounter)}
          value={emailCode}
          onChange={(e) => {
            const { value } = e.target;
            setEmailCode(value);
          }}
          actionLabel="Resend"
          actionClick={resendEmailCode}
          actionDisabled={emailCounter !== 0}
          placeholder={translate('whitelist_verify_code_email')}
          autoFocus
          withFloatingLabel
          withSubLabel
        />
      )}
      {totpConfirmationEnabled && (
        <Input
          label={
            isUsingTotp
              ? translate('whitelist_verify_code_totp')
              : translate('whitelist_verify_code_phone_number')
          }
          subLabel={
            isUsingTotp
              ? translate('whitelist_verify_totp')
              : translate('whitelist_verify_code_phone_number_description')
                  .replace('%s', starredPhoneNumber())
                  .replace('%d', phoneCounter)
          }
          value={phoneCode}
          onChange={(e) => {
            const { value } = e.target;
            setPhoneCode(value);
          }}
          actionLabel="Resend"
          actionDisabled={phoneCounter !== 0}
          actionClick={isUsingTotp ? null : resendPhoneCode}
          placeholder={
            isUsingTotp
              ? translate('whitelist_verify_code_totp')
              : translate('whitelist_verify_code_phone_number')
          }
          withFloatingLabel
          withSubLabel
        />
      )}
    </>
  );
};

WhitelistVerifyComponent.propTypes = {
  emailConfirmationEnabled: PropTypes.bool.isRequired,
  totpConfirmationEnabled: PropTypes.bool.isRequired,
  isUsingTotp: PropTypes.bool.isRequired,
  emailCode: PropTypes.string.isRequired,
  phoneCode: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  emailCounter: PropTypes.number,
  phoneCounter: PropTypes.number,
  setEmailCode: PropTypes.func.isRequired,
  setPhoneCode: PropTypes.func.isRequired,
  resendPhoneCode: PropTypes.func.isRequired,
  resendEmailCode: PropTypes.func.isRequired,
  starredPhoneNumber: PropTypes.func.isRequired,
};

WhitelistVerifyComponent.defaultProps = {
  emailCounter: 0,
  phoneCounter: 0,
};
